var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _c(
        "div",
        { staticClass: "cloum" },
        [
          _vm.applyType === "signList"
            ? [
                _vm.rowData[_vm.fields.signStatus] === 2
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "color-success",
                          on: {
                            click: function($event) {
                              _vm.refuseResonVisible = true
                            }
                          }
                        },
                        [_vm._v("查看拒签原因")]
                      )
                    ]
                  : _vm._e(),
                _vm.rowData[_vm.fields.signStatus] === 0
                  ? [
                      _vm.rowData.selfSign === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.toSign(
                                    _vm.rowData[_vm.fields.signNo],
                                    _vm.rowData.approveId,
                                    _vm.rowData.multiFile,
                                    _vm.rowData.aiCorpUserIdFlag
                                  )
                                }
                              }
                            },
                            [_vm._v("签署")]
                          )
                        : [
                            _vm.rowData.isReminderSign === 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("再催")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("催签")]
                                )
                          ],
                      _vm.selfAuthFn(_vm.rowData)
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.batchCancel(_vm.rowData)
                                }
                              }
                            },
                            [_vm._v("撤销")]
                          )
                        : _vm._e(),
                      _vm.selfAuthFn(_vm.rowData) &&
                      _vm.rowData.applySignCreateType !== 0 &&
                      _vm.rowData.createType !== 0
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.getNoSingInfo(_vm.rowData.applyNo)
                                }
                              }
                            },
                            [_vm._v("链接")]
                          )
                        : _vm._e()
                    ]
                  : _vm.rowData[_vm.fields.signStatus] === 1
                  ? [
                      _c(
                        "certiServicepopover",
                        {
                          staticClass: "color-success",
                          attrs: {
                            listType: "userList",
                            param: {
                              signNo: _vm.rowData[this.fields.signNo] || "",
                              applyNo: _vm.rowData.applyNo || ""
                            },
                            newUrl: 0
                          }
                        },
                        [_vm._v("出证")]
                      ),
                      _c(
                        "certiServicepopover",
                        {
                          attrs: {
                            listType: "userList",
                            newUrl: 1,
                            param: {
                              signNo: _vm.rowData[this.fields.signNo] || "",
                              applyNo: _vm.rowData.applyNo || ""
                            }
                          }
                        },
                        [
                          _c(
                            "el-badge",
                            {
                              staticClass: "color-success",
                              staticStyle: { float: "right", top: "5px" },
                              attrs: { "is-dot": _vm.rowData.hasCert == 1 }
                            },
                            [_vm._v("证书")]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm.rowData[_vm.fields.signStatus] === -6
                  ? [_c("span")]
                  : _vm._e()
              ]
            : _vm.applyType === "applyList"
            ? [
                _vm.rowData[_vm.fields.signStatus] === 2
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "color-success",
                          on: {
                            click: function($event) {
                              _vm.refuseResonVisible = true
                            }
                          }
                        },
                        [_vm._v("查看拒签原因")]
                      )
                    ]
                  : _vm._e(),
                _vm.rowData[_vm.fields.signStatus] === 0
                  ? [
                      _vm.rowData.selfSign === 1
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "color-success",
                                on: {
                                  click: function($event) {
                                    return _vm.toSign(
                                      _vm.rowData.signNo,
                                      _vm.rowData.approveId,
                                      _vm.rowData.multiFile,
                                      _vm.rowData.aiCorpUserIdFlag
                                    )
                                  }
                                }
                              },
                              [_vm._v("签署")]
                            ),
                            _vm.fileSelfAuthFn(_vm.rowData)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.batchCancel(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("撤销")]
                                )
                              : _vm._e()
                          ]
                        : [
                            _vm.fileSelfAuthFn(_vm.rowData)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.batchCancel(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("撤销")]
                                )
                              : _vm._e(),
                            _vm.rowData.isReminderSign === 1 &&
                            _vm.fileSelfAuthFn(_vm.rowData)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("再催")]
                                )
                              : _vm.rowData.isReminderSign === 0 &&
                                _vm.fileSelfAuthFn(_vm.rowData)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("催签")]
                                )
                              : _vm._e(),
                            _vm.rowData.showQrCode === 1 &&
                            _vm.fileSelfAuthFn(_vm.rowData) &&
                            _vm.rowData.applySignCreateType !== 0 &&
                            _vm.rowData.createType !== 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.getNoSingInfo(
                                          _vm.rowData.applyNo
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("链接")]
                                )
                              : _vm._e()
                          ]
                    ]
                  : _vm.rowData[_vm.fields.signStatus] === -6
                  ? [_c("span")]
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "获取签署链接",
            visible: _vm.visibleNoSignList,
            "modal-append-to-body": "",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": true,
            width: "550px",
            "custom-class": "my-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleNoSignList = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    value: _vm.noSign.signNo,
                    placeholder: "选择待签署方"
                  },
                  on: {
                    input: function(val) {
                      _vm.dselect(val)
                    }
                  }
                },
                _vm._l(_vm.noSign.data, function(item) {
                  return _c("el-option", {
                    key: item.signNo,
                    staticClass: "my-dialog-select",
                    attrs: { label: item.fullName, value: item.signNo }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex", staticStyle: { margin: "15px auto" } },
            [_vm._v("将下方二维码或链接复制发送给对方，即可进行签署。")]
          ),
          _c("div", { staticClass: "flex dashed" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "div",
                  { staticClass: "qrcode" },
                  [
                    _vm.showQy
                      ? _c("qrcode", {
                          key: "evidence",
                          attrs: {
                            value: _vm.noSign.url,
                            size: 140,
                            leave: "H"
                          }
                        })
                      : _c("span", { staticClass: "ne-text" }, [
                          _vm._v("请先选择签署方")
                        ])
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "b-btn",
                    attrs: { disabled: !_vm.showQy },
                    on: { click: _vm.saveQr }
                  },
                  [_vm._v("保存二维码")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "div",
                  {
                    staticStyle: { padding: "10px", "box-sizing": "border-box" }
                  },
                  [
                    _vm.showQy
                      ? [_vm._v(_vm._s(_vm.noSign.url))]
                      : _c("span", { staticClass: "ne-text" }, [
                          _vm._v("请先选择签署方")
                        ])
                  ],
                  2
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "b-btn",
                    attrs: {
                      disabled: !_vm.showQy,
                      id: "tag-copy",
                      "data-clipboard-text": _vm.noSign.url
                    },
                    on: {
                      click: function($event) {
                        return _vm.copyText($event)
                      }
                    }
                  },
                  [_vm._v("复制签署链接")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "拒签原因",
            visible: _vm.refuseResonVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.refuseResonVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("p", [
              _vm._v(
                "签约方：" +
                  _vm._s(_vm.rowData.signInfoVOS[0].signatoryFullName)
              )
            ]),
            _c("div", [
              _vm._v(
                "拒签原因：" + _vm._s(_vm.rowData.signInfoVOS[0].refuseReason)
              )
            ])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.refuseResonVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bde5ad4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bde5ad4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/handles.vue
// module id = 4/MM
// module chunks = 29 43 47 50